import { Component, ViewChild, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs/Subscription";

import { MapService } from "../../map/map.service";
import { MapValuesService } from "../../map/map-values.service";
import { ProgramEditorService } from "../../common/program-editors/program-editor.service";
import { ProgramAreaSearchResult } from "@models/common";
import { AutoComplete } from "primeng/primeng";
import { AreaMapRequest } from "@models/map";

@Component({
    templateUrl: "./public-layout.component.html"
})

export class PublicLayoutComponent implements OnDestroy {
    public routerSub: Subscription;
    @ViewChild("searchbar") searchbar: AutoComplete;
    public searchResults: ProgramAreaSearchResult[];
    public searchSelection: ProgramAreaSearchResult;

    constructor(private mapService: MapService, public router: Router,
        private programEditorService: ProgramEditorService, private mapValuesService: MapValuesService) {
        this.routerSub = this.router.events.pairwise()
            .filter(x => x[0] instanceof NavigationEnd && x[1] instanceof NavigationStart)
            .subscribe(e => {
                let prev = <NavigationEnd>e[0];
                let curr = <NavigationEnd>e[1];
                this.programEditorService.previousUrl = prev.url;
            });
    }

    ngOnDestroy(): void {
        this.routerSub.unsubscribe();
    }

    search(event) {
        let query = event.query;

        let search = {
            phrase: query,
            pageLimit: 200
        };

        this.mapService.searchProgramsAndAreas(search).subscribe(
            response => this.searchResults = [...response]
        );
    }

    searchFocus(event) {
        let shown = this.searchbar.panelVisible;
        if (shown) { return; }
        let queryValue = this.searchbar.inputEL.nativeElement.value;
        if (queryValue == undefined) { queryValue = ""; }

        this.searchbar.search(event, queryValue);
    }

    updateSearch(event) {
        if (!event.hasOwnProperty("id")) {
            this.clearSearchbar();
            return;
        }

        let id = event.id;
        let area = event.areaTypeId;
        if (event.areaTypeId === 0) {
            let link = "/public-profile/" + id;
            this.router.navigate([link]);
        } else {
            let url = this.router.url;
            let filters: AreaMapRequest = {
                areaType: area,
                id: id,
                grades: [],
                programsOffered: []
            };

            if (url.indexOf("map") !== -1) {
                this.mapValuesService.triggerMapUpdate(filters);
            } else {
                let json = JSON.stringify(filters);
                localStorage.setItem("map-filters", json);

                this.router.navigate(["/map"]);
            }
        }
        this.clearSearchbar();
    }

    clearSearchbar(): void {
        this.searchSelection = undefined;
        this.searchbar.inputEL.nativeElement.value = "";
        setTimeout(() => this.searchbar.inputEL.nativeElement.blur());
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/layout/public-layout/public-layout.component.ts